// components/TokenChecker.js
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";

export default function TokenChecker() {
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const navigate = useNavigate();

  const handleClose = () => setSnackOpen(false);

  useEffect(() => {
    const handleTokenStatus = (e) => {
      const { status, code } = e.detail;
      console.log("handletoken statue", status, code);
      if (status === "expired") {
        localStorage.clear();
        setSnackMessage("🔒 Session expired. Please log in again.");
        navigate("/signin");
      } else if (status === "error" && code === 404) {
        localStorage.clear();
        navigate("/signin");
        setSnackMessage("❌ Invalid token. Please log in again.");
      }
      setSnackOpen(true);
      // setTimeout(() => {
      //   navigate("/signin");
      // }, 2000);
    };

    window.addEventListener("tokenStatus", handleTokenStatus);

    return () => {
      window.removeEventListener("tokenStatus", handleTokenStatus);
    };
  });

  return (
    <Snackbar
      open={snackOpen}
      autoHideDuration={4000}
      onClose={handleClose}
      message={snackMessage}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    />
  );
}
